import { useContext } from "react";
import { IntakesDrawerContext } from "./IntakesDrawerProvider";

export const useIntakeDrawer = () => useContext(IntakesDrawerContext);
